import { message } from 'antd'
import './AppToaster.css'

export class AppToaster {
  showSuccessToast = (stringMessage: string, duration?: number) => {
    message.success({ content: stringMessage, className: 'toaster-div success-toaster', duration: duration ?? 2 })
  }

  showErrorToast = (stringMessage: string, duration?: number) => {
    message.error({ content: stringMessage, className: 'toaster-div error-toaster', duration: duration ?? 2 })
  }

  showWarningToast = (stringMessage: string, duration?: number) => {
    message.warning({ content: stringMessage, className: 'toaster-div warning-toaster', duration: duration ?? 2 })
  }
}
